<template>
  <div class="landing">
    <h1>FAP</h1>
    <input type="file" ref="input" />
    <router-link :to="{ name: 'presentation' }" v-if="!getVideoData"
      >SKIP</router-link
    >
    <template v-else>
      <div class="content" v-if="getVideoData">
        <div class="segments">Segments: {{ segments }}</div>
        <div class="transitions">Transitions: {{ transitions }}</div>
      </div>
      <router-link :to="{ name: 'presentation' }" v-if="getVideoData"
        >GO</router-link
      >
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import timings from "@/mixins/timings";

export default {
  mixins: [timings],
  data() {
    return {
      data: null,
    };
  },
  mounted() {
    this.$nextTick(() => {
      let input = this.$refs.input;

      input.addEventListener("change", (e) => {
        let file = e.target.files[0];

        const reader = new FileReader();

        reader.addEventListener(
          "load",
          () => {
            let data = JSON.parse(reader.result);
            this.setVideoData(data);
            this.data = data;
            // this.$router.push({ name: "presentation" });
          },
          false
        );

        if (file) {
          reader.readAsText(file);
        }
      });
    });
  },
  methods: {
    ...mapActions(["setVideoData"]),
  },
  computed: {
    ...mapGetters(["getVideoData"]),
  },
};
</script>

<style lang="scss" scoped>
.landing {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  height: 100vh;
  align-items: center;
}
</style>